/*jslint white: true, browser: true, devel: true, nomen: true, sloppy: true, indent: 4, maxerr: 50,	 plusplus: true, vars: false */
/*jshint -W030, -W041, -W083 */
/*globals define, module, SliderView */

function DataBlocks() {
    'use strict';
    var version = '1.0.2_dev';

    var self = this;
    var sizingObj, customerSystem, sizingSystem, gender;
    var sliderWidth = null, sliderHeight = null, sliderGirth = null;
    var measurment = null;
    var container, elements = {};
    var template = null; // this will host the template DOM
    self.lastScan = null;
    var availableBlocks = ['size', 'width', 'length', 'arch_type', 'height', 'girth', 'shoe_size_range', 'insoles', 'video'];

    self.viewConfig = {
        debug: false,
        locale: 'EN',
        modelVersion: '3D',
        skin: 'safesize.2x3.safesize',
        forcedSizingSystems: []
    };

    var log = Logger();


    var euSystemPercentage = { '0.0': ['12', '76', '12'],
                            '0.1': ['10', '70', '20'],
                            '0.2': ['8', '65', '27'],
                            '0.3': ['6', '60', '34'],
                            '0.4': ['4', '55', '41'],
                            '0.5': ['50', '48', '2'],
                            '0.6': ['41', '55', '4'],
                            '0.7': ['34', '60', '6'],
                            '0.8': ['27', '65', '8'],
                            '0.9': ['20', '70', '10']};
    var ukUsSystemPercentage = {'0.0': ['20', '60', '20'],
                            '0.1': ['15', '55', '30'],
                            '0.2': ['10', '50', '40'],
                            '0.3': ['40', '50', '10'],
                            '0.4': ['30', '55', '15'],
                            '0.5': ['20', '60', '20'],
                            '0.6': ['15', '55', '30'],
                            '0.7': ['10', '50', '40'],
                            '0.8': ['40', '50', '10'],
                            '0.9': ['30', '55', '15']};

    self.skins = { // here we add new skins when they come.
        safesize: {
            '2x3': {
                safesize: { // this is the default configuration
                    blocksPerLine: 2, // default blocks per line (desktop)
                    showInfoCircles: false, // hides the info circles, keep it this way until info is implemented
                    showChangeCircles: false, // shows the change circles
                    // customerSystem: 'DUREA', //if defined this system is default
                    // sizingSystem: 'EU', //if defined this sizing is default;
                    // forcedSizingSystems: ['EU'], //if defined only the sizingSystems in this array are allowed, all others are dropped.
                    order: ['size', 'width', 'length', 'arch_type', 'height', 'girth'], // determines the order in which the blocks will show, (0,1 are first line / 2,3 are in second line / 4,5 are in bottom line)
                    selectable: true, // determines wheter or not the boxes are selectable.
                    customColors: { // custom colours to overwrite the default ones
                        box1: '#3A4652', // main background color (regular) (default is #3A4652)
                        box2: '#424F5C', // highlight background color (hover) (default is #424F5C)
                        box3: '#999999', // highlight border color (hover) (default is #999999)
                        box4: '#333D48', // selected background color (selected) (default is #333D48)
                        box5: '#4FABE0', // selected and hover selected border color (selected, selected+hover) (default is #4FABE0)
                        box6: '#333333', // selected and hover selected box shadow color (selected, selected+hover) (default is #333333)
                        text1: '#FFFFFF', // main text color + slider inner bars (default is #FFFFFF)
                        text2: '#98A1AA', // secondary text and checkbox unchecked color (default is #98A1AA)
                        text3: '#4FABE0', // slider left/right text + triangle colour (default is #4FABE0)
                        text4: '#AAAAAA', // slider outer bars + slider text (default is #AAAAAA)
                        feet: 'gray', // white, gray or black (default is gray)
                        cbox1: '#4FABE0', // checkbox hover and checked color (default is #4FABE0)
                        cbox2: '#98A1AA', // checkbox unchecked color (default is #98A1AA)
                        cboxf: 'brightness(1)', // combination of !filters! (hue-rotate, grayscale, brightness, contrast, ...) to apply to checkbox to get the desired color (default color is #52C2F4)
                        sbox1: '#333D48' // select box background (default is #333D48)
                    }
                },
                xebio: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    sizingSystem: 'JP',
                    order: ['size', 'width', 'length', 'arch_type', 'height'],
                    selectable: true
                },
                ls: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    order: ['size', 'width', 'length', 'arch_type', 'height', 'girth'],
                    selectable: true
                }
            },
            '2x2': {
                intersport: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true
                },
                no_arch: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    order: ['size', 'length', 'width', 'height'],
                    selectable: true
                },
                omoda: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    order: ['length', 'width', 'height', 'girth'],
                    selectable: true
                },
                xebio: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    sizingSystem: 'JP',
                    order: ['size', 'length', 'width', 'arch_type'],
                    selectable: true
                }
            },
            '1x3': {
                torfs: {
                    blocksPerLine: 1,
                    showInfoCircles: false,
                    order: ['size', 'length', 'width'],
                    selectable: false,
                    customColors: {
                        box1: '#FFCC00',
                        text1: '#3B3F3A',
                        text2: '#3B3F3A',
                        text3: '#3B3F3A',
                        text4: '#3B3F3A',
                        sbox1: '#E4B806'
                    }
                },
                van_haren: {
                    blocksPerLine: 1,
                    showInfoCircles: false,
                    order: ['length', 'width', 'height'],
                    selectable: true,
                    customColors: {
                        box1: '#EB690A',
                        box2: '#EF873A',
                        box3: '#D35E09',
                        box4: '#D35E09',
                        box5: '#A44907',
                        box6: '#A44907',
                        text1: '#FFF',
                        text2: '#CCC',
                        text3: '#FFF',
                        text4: '#CCC',
                        feet: 'white',
                        cbox1: '#FFF',
                        cbox2: '#CCC',
                        cboxf: 'grayscale(100%) brightness(200%)'
                    }
                }
            }
        },
        eobuwie: {
            '2x2': {
                eobuwie: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    order: ['width', 'length', 'height', 'girth'],
                    selectable: false
                }
            }
        },
        esizemev2: {
            '2x2': {
                esizemev2: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    hideSelectCircles: true,
                    order: ['length', 'width', 'height', 'girth'],
                    selectable: true,
                    forcedSizingSystems: ['EU']
                }
            }
        },
        ccc: {
            '2x2': {
                ccc: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    hideSelectCircles: true,
                    order: ['length', 'width', 'height', 'girth'],
                    selectable: true
                },
                esizeme: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    hideSelectCircles: true,
                    order: ['size', 'length', 'width', 'height'],
                    selectable: true,
                    forcedSizingSystems: ['EU']
                }
            },
            '1x3': {
                esizeme: {
                    blocksPerLine: 1,
                    showInfoCircles: false,
                    hideSelectCircles: true,
                    order: ['length', 'width', 'height'],
                    selectable: true,
                    forcedSizingSystems: ['EU']
                }
            }
        },
        ls: {
            '2x3': {
                ls: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['shoe_size_range', 'length', 'width', 'height', 'girth'],
                    selectable: true,
                    cssClass: ['ls_range']
                },
                ls_range: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['shoe_size_range', 'length', 'width', 'height', 'girth'],
                    selectable: true,
                    cssClass: ['ls_range']
                }
            },
            '2x2': { //Because of LS request this skin was changed to ls.2x3.ls_range
                ls: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['shoe_size_range', 'length', 'width', 'height', 'girth'],
                    selectable: true,
                    cssClass: ['ls_range']
                }
            }
        },
        nb: {
            '2x3': {
                nb: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'girth', 'arch_type'],
                    selectable: true
                },
            },
            '2x2': {
                nb: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true
                },
            }
        },
        safesizev2: {
            '1x1': {
                van_haren: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['video'],
                    selectable: true
                }
            },
            '2x3': {
                safesize: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['size', 'width', 'length', 'arch_type', 'height', 'girth'],
                    selectable: true,
                    cssClass: ['smaller']
                },
                no_girth: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['size', 'width', 'height', 'arch_type', 'length'],
                    selectable: true,
                    cssClass: ['no_girth_2_3', 'smaller']
                },
                no_size: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'girth', 'arch_type'],
                    selectable: true,
                    cssClass: ['no_size_2_3', 'smaller']
                },
                xebio: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    sizingSystem: 'JP',
                    order: ['size', 'width', 'length', 'arch_type', 'height'],
                    selectable: true,
                    cssClass: ['xebio_2_3', 'smaller', 'xebio']
                },
                xebio_arch: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    sizingSystem: 'JP',
                    order: ['size', 'width', 'length', 'arch_type', 'height'],
                    selectable: true,
                    clickableArchType: true,
                    cssClass: ['xebio_2_3', 'smaller', 'xebio']
                },
                black: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'girth', 'arch_type'],
                    selectable: true,
                    cssClass: ['black', 'no_size_2_3', 'smaller']
                },
                ls: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    order: ['size', 'width', 'length', 'arch_type', 'height', 'girth'],
                    selectable: true,
                    cssClass: ['smaller']
                },
                van_haren: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['shoe_size_range', 'length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: ['van_haren']
                },
                intersport: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['size', 'width', 'length', 'arch_type', 'height', 'girth'],
                    selectable: true,
                    cssClass: ['intersport', 'smaller']
                },
                intersport_insoles: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['size', 'length', 'width', 'arch_type', 'insoles'],
                    selectable: true,
                    cssClass: ['intersport', 'smaller']
                },
                van_haren_perc: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['shoe_size_range_perc', 'length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: ['perc_range', 'van_haren']
                },
                percentage: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['shoe_size_range_perc', 'length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: ['perc_range']
                },
                hotter: { //same as van_haren
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['shoe_size_range', 'length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: ['hotter']
                },
                ziengs: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['size', 'width', 'length', 'arch_type', 'height', 'girth'],
                    selectable: true,
                    cssClass: ['smaller']
                },
                voswinkel: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    clickableArchType: true, 
                    order: ['length', 'width', 'height', 'arch_type', 'size', 'girth'],
                    selectable: true,
                    cssClass: ['smaller']
                },
                insoles: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    clickableArchType: true, 
                    order: ['length', 'width', 'height', 'arch_type', 'insoles'],
                    selectable: true,
                    cssClass: ['smaller']
                },
                pentaloop: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    clickableArchType: true, 
                    order: ['length', 'width', 'height', 'arch_type', 'insoles'],
                    selectable: true,
                    cssClass: ['smaller', 'pentaloop']
                },
                lenz: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    clickableArchType: true, 
                    order: ['length', 'width', 'height', 'arch_type', 'insoles'],
                    selectable: true,
                    cssClass: ['smaller', 'lenz']
                },
                superfeet: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    clickableArchType: true,
                    order: ['length', 'width', 'height', 'arch_type', 'insoles'],
                    selectable: true,
                    cssClass: ['smaller', 'superfeet']
                },
                marathon: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'girth', 'arch_type'],
                    selectable: true,
                    cssClass: ['smaller', 'no_size_2_3']
                },
            },
            '2x2': {
                safesize: { //the same as intersport
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: []
                },
                dec: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: ['dec']
                },
                intersport: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: ['intersport', 'smaller']
                },
                black: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: ['black', 'smaller']
                },
                no_arch: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    order: ['size', 'length', 'width', 'height'],
                    selectable: true
                },
                omoda: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    order: ['length', 'width', 'height', 'girth'],
                    selectable: true
                },
                xebio: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    sizingSystem: 'JP',
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: ['xebio']
                },
                xebio_arch: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    sizingSystem: 'JP',
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    clickableArchType: true,
                    cssClass: ['xebio']
                },
                no_height: { // safesize but no height
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'arch_type'],
                    selectable: true,
                    cssClass: ['no_height']
                },
                apparel: { // same as safesize
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: []
                },
                hoka: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    clickableArchType: true, 
                    cssClass: ['smaller']
                },
                salomon: {
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: ['smaller', 'salomon']
                },
                marathon: { // same as safesize
                    blocksPerLine: 2,
                    showInfoCircles: false,
                    showChangeCircles: false,
                    order: ['length', 'width', 'height', 'arch_type'],
                    selectable: true,
                    cssClass: []
                }
            }
        }
    };
    self.skins.safesizev2["2x2"].zero = self.skins.safesizev2["2x2"].black;

    self.sliderSkins = {
        safesize: {
            allCaps: true,
            textCentered: false,
            textFont: '10px UCSLato',
            textFontLR: '10px UCSLato',
            textLRBold: false,
            sliderTextColor: '#AAAAAA',
            footTextColor: '#4FABE0',
            sliderBackgroundColor: 'transparent',
            sliderOuterBarsColor: '#AAAAAA',
            sliderInnerBarsColor: '#FFFFFF',
            sliderTriangleColor: '#4FABE0',
            sliderHeight: 25,
            sliderBorderRadius: 0,
            sliderSideMargin: 5,
            sliderSidePadding: 10,
            sliderOuterBarsWidth: 2,
            sliderInnerBarsWidth: 2,
            sliderInnerBarsFractionHeight: 3,
            footTextMargin: 8,
            triangleWidth: 10,
            triangleHeight: 12,
            sliderOuterBarsVisible: true
        },
        eobuwie: {
            allCaps: false,
            textCentered: true,
            textFont: '14px Averta',
            textFontLR: '16px Averta',
            textLRBold: true,
            sliderTextColor: '#757575',
            footTextColor: '#4caf50',
            sliderBackgroundColor: '#f4f4f4',
            sliderOuterBarsColor: '#AAAAAA',
            sliderInnerBarsColor: '#e0e0e0',
            sliderTriangleColor: '#4caf50',
            sliderHeight: 32,
            sliderBorderRadius: 0,
            sliderSideMargin: 0,
            sliderSidePadding: 10,
            sliderOuterBarsWidth: 0,
            sliderInnerBarsWidth: 1,
            sliderInnerBarsFractionHeight: 1.04,
            footTextMargin: 24,
            triangleWidth: 12,
            triangleHeight: 6,
            sliderOuterBarsVisible: false
        },
        ccc: {
            allCaps: false,
            textCentered: true,
            textFont: '14px Averta',
            textFontLR: '16px Averta',
            textLRBold: true,
            sliderTextColor: '#757575',
            footTextColor: '#1474CC',
            sliderBackgroundColor: '#F4F4F4',
            sliderOuterBarsColor: '#AAAAAA',
            sliderInnerBarsColor: '#E0E0E0',
            sliderTriangleColor: '#1474CC',
            sliderHeight: 32,
            sliderBorderRadius: 7,
            sliderSideMargin: 0,
            sliderSidePadding: 10,
            sliderOuterBarsWidth: 0,
            sliderInnerBarsWidth: 1,
            sliderInnerBarsFractionHeight: 1.04,
            footTextMargin: 24,
            triangleWidth: 12,
            triangleHeight: 6,
            sliderOuterBarsVisible: false
        },
        ls: this.safesize,
        nb: {
            allCaps: true,
            textCentered: false,
            textFont: '10px UCSLato',
            textFontLR: '10px UCSLato',
            textLRBold: false,
            sliderTextColor: '#AAAAAA',
            footTextColor: '#E04F54',
            sliderBackgroundColor: 'transparent',
            sliderOuterBarsColor: '#AAAAAA',
            sliderInnerBarsColor: '#FFFFFF',
            sliderTriangleColor: '#E04F54',
            sliderHeight: 25,
            sliderBorderRadius: 0,
            sliderSideMargin: 5,
            sliderSidePadding: 10,
            sliderOuterBarsWidth: 2,
            sliderInnerBarsWidth: 2,
            sliderInnerBarsFractionHeight: 3,
            footTextMargin: 8,
            triangleWidth: 10,
            triangleHeight: 12,
            sliderOuterBarsVisible: true
        }
        //safesizev2 is not needed, sliders/canvases are not used
    };

    function getTemplate (callback) { //loads the datablocks template for skin
        if (self.viewConfig.skin.split('.')[0] === 'safesize') { //don't try to load safesize_template.html, but instead directly load template.html (default)
            return getDefaultTemplate(callback);
        }
        var xhr = new XMLHttpRequest();
        xhr.open('GET', self.viewConfig.skin.split('.')[0] + '_template.html', true);
        xhr.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status !== 200) {
                log(this);
                getDefaultTemplate(callback);
                return;
            }
            callback(this.response);
        };
        xhr.send();
    }

    function getDefaultTemplate (callback) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', 'template.html', true);
        xhr.onreadystatechange = function () {
            if (this.readyState !== 4) return;
            if (this.status !== 200) {
                log(this);
                callback(null);
                return;
            }
            callback(this.response);
        };
        xhr.send();
    }

    function Logger () {
        if(self.viewConfig.debug) {
            // console.log('Debugging enabled.');
            return console.log;
        } else {
            // console.log('Debugging disabled.');
            return function () {};
        }
    }

    this.updateConfig = function (config) { //update config at runtime (handle the width change for canvases in your code)
        log('Updating datablocks config: ', config);
        updateViewConfig(config);
        initSubtask(true);
    };

    function initSubtask(update) { // init subtask, hides infocircles if needed and maps required elements, when done sends event back that init is complete
        var skinParams = self.viewConfig.skin.split('.');
        container.classList.add(skinParams[0]);

        if (isSafesizeV2Skin() || isLsRangeSkin()) {
            if (!!self.viewConfig.cssClass && self.viewConfig.cssClass.length > 0) {
                for (var ix = 0; ix < self.viewConfig.cssClass.length; ix++) {
                    container.classList.add(self.viewConfig.cssClass[ix]);
                }
            }
        }

        var orderedElements = document.createDocumentFragment();
        self.viewConfig.order.forEach(function (el) {
            orderedElements.appendChild(template.querySelector('#datablocks_block_' + el).cloneNode(true));
        });
        container.innerHTML = ''; //IE and Edge don't work well with null
        container.appendChild(orderedElements);

        if (self.viewConfig.hideSelectCircles) {
            var topContainers = document.getElementsByClassName('topright_container');
            for (var i = 0; i < topContainers.length; i++) {
                if (!self.viewConfig.showInfoCircles) {
                topContainers[i].classList.add('datablocks_removed');
                } else {
                    var topContainer = topContainers[i];
                    var cbox = topContainer.querySelector('input.checkbox-safesize');
                    var label = topContainer.querySelector('label[for=' + cbox.id + ']');
                    if (cbox) cbox.classList.add('datablocks_removed');
                    if (label) label.classList.add('datablocks_removed');
                }
            }
        } else if (!self.viewConfig.showInfoCircles) {
            var infoCircles = document.getElementsByClassName('info_icon');
            for (var j = 0; j < infoCircles.length; j++) {
                infoCircles[j].classList.add("datablocks_removed");
            }
        }


        elements.block_size = document.getElementById('datablocks_block_size');
        elements.block_width = document.getElementById('datablocks_block_width');
        elements.block_length = document.getElementById('datablocks_block_length');
        elements.block_arch_type = document.getElementById('datablocks_block_arch_type');
        elements.block_height = document.getElementById('datablocks_block_height');
        elements.block_girth = document.getElementById('datablocks_block_girth');
        elements.block_insoles = document.getElementById('datablocks_block_insoles');
        elements.block_video = document.getElementById('datablocks_block_video');
        elements.block_shoe_size_range = isPercentageSkin() ? document.getElementById('datablocks_block_shoe_size_range_perc') : document.getElementById('datablocks_block_shoe_size_range');
        //
        if (elements.block_arch_type) elements.arch_icon = elements.block_arch_type.querySelector('.arch_icon');
        elements.slider_width = document.getElementById('datablocks_sliderWidth');
        elements.slider_width_wrapper = document.getElementById('datablocks_sliderWidthWrapper');
        elements.slider_height = document.getElementById('datablocks_sliderHeight');
        elements.slider_height_wrapper = document.getElementById('datablocks_sliderHeightWrapper');
        elements.slider_girth = document.getElementById('datablocks_sliderGirth');
        elements.slider_girth_wrapper = document.getElementById('datablocks_sliderGirthWrapper');
        elements.size_csystem = document.getElementById('datablocks_customer-system');
        elements.size_ssystem = document.getElementById('datablocks_sizing-system');
        elements.shoe_size_range_csystem = isPercentageSkin() ? document.getElementById('datablocks_shoe-size-perc-customer-system') : document.getElementById('datablocks_shoe-size-range-customer-system');
        elements.shoe_size_range_ssystem = isPercentageSkin() ? document.getElementById('datablocks_shoe-size-perc-sizing-system') : document.getElementById('datablocks_shoe-size-range-sizing-system');

        if (self.viewConfig.showChangeCircles) {
            for (var k = 0; k < self.viewConfig.showChangeCircles.length; k++) {
                var block_name = self.viewConfig.showChangeCircles[k];
                var blocks = elements['block_' + block_name] ? elements['block_' + block_name].getElementsByClassName("change_icon") : []; // handling for cases where the datablock is removed!
                if (blocks.length > 0) {
                    var changeCircle = blocks[0];
                    changeCircle.classList.remove("datablocks_removed");
                    changeCircle.addEventListener('click', onChange);
                }

            }
        }

        updateBlocks();

        applyThemeColoring();

        if(update) {
            if (self.viewConfig.locale && self.localization) {
                self.setLocalization();
            }
            if (self.lastScan) {
                self.setData();
            }
            self.callback('UPDATE_COMPLETE', {view: 'dataBlocks'});
        } else {
            self.callback('INIT_COMPLETE', {view: 'dataBlocks'});
        }
    }

    function updateBlocks () { // updates blocks (depending on the blocksPerLine parameters)
        if (self.viewConfig.blocksPerLine === 1 || self.viewConfig.modelVersion === '2D') {
			self.callback && self.callback('LAYOUT', {view: 'dataBlocks', data: 'single_column'});
            container.classList.add('single_col');
            var idx = 0; var max = self.viewConfig.order.length;
            if(self.viewConfig.modelVersion === '2D') {
                var found2D = 0;
                availableBlocks.slice(0,3).forEach(function (key) {
                    if(self.viewConfig.order.indexOf(key) > -1) {
                        found2D++;
                    }
                });
                max = found2D;
            }
            self.viewConfig.order.forEach(function (key) {
                elements['block_' + key].classList.remove('leftmargin');
                elements['block_' + key].classList.remove('marginbottom');
                if(self.viewConfig.modelVersion === '2D' && availableBlocks.slice(0,3).indexOf(key) === -1) { // only first 3 blocks are eligible for 2D mode
                    elements['block_' + key].classList.add('datablocks_removed');
                }
                if (idx % 2 !== 0) {
                    elements['block_' + key].classList.add('leftmargin');
                }
                if (idx < max - 1) {
                    elements['block_' + key].classList.add('marginbottom');
                }
                idx++;
            });
        } else {
			self.callback && self.callback('LAYOUT', {view: 'dataBlocks', data: 'double_column'});
            container.classList.remove('single_col');
            if([2, 3].indexOf(self.viewConfig.blocksPerLine) !== -1) container.classList.add('col_' + self.viewConfig.blocksPerLine);
            self.viewConfig.order.forEach(function (key, idx) {
                key.indexOf('_perc') > 0 ? key = key.replace('_perc', '') : key;
                elements['block_' + key].classList.remove('datablocks_removed');
                elements['block_' + key].classList.remove('leftmargin');
                elements['block_' + key].classList.remove('marginbottom');
                if(idx % self.viewConfig.blocksPerLine !== 0) {
                    elements['block_' + key].classList.add('leftmargin');
                }
                if(idx < Math.ceil(self.viewConfig.order.length / self.viewConfig.blocksPerLine)*self.viewConfig.blocksPerLine - self.viewConfig.blocksPerLine) {
                    elements['block_' + key].classList.add('marginbottom');
                }
            });
        }
    }

    function skinExists(skin) {
        if(typeof skin === 'string') {
            var skinParts = skin.split('.');
            if(skinParts.length === 3 && self.skins[skinParts[0]] && self.skins[skinParts[0]][skinParts[1]] && typeof self.skins[skinParts[0]][skinParts[1]][skinParts[2]] === 'object') {
                return true;
            }
        }
        return null;
    }

    function updateViewConfig(viewConfig) {

        if (typeof viewConfig.debug === "boolean") {
            self.viewConfig.debug = viewConfig.debug;
            log = Logger();
        }

        var tempViewConfig = {
            locale: viewConfig.locale || self.viewConfig.locale,
            modelVersion: viewConfig.modelVersion || self.viewConfig.modelVersion,
            skin: skinExists(viewConfig.skin) ? viewConfig.skin : viewConfig.skin.indexOf('safesizev2') >= 0 ? 'safesizev2.2x3.safesize' :self.viewConfig.skin,
            sliderSkin: self.viewConfig.sliderSkin || 'safesize' //keep the sliderSkin on update.
        };
        var sp = tempViewConfig.skin.split('.');
        var defaultSkin = self.skins[sp[0]][sp[1]][sp[2]];
        for(var prop in defaultSkin) { // populate viewConfig with default skin values
            if(defaultSkin.hasOwnProperty(prop))
                tempViewConfig[prop] = defaultSkin[prop];
        }

        for(var param in viewConfig) { // override viewConfig with
            if(param === 'order') { // additional logit to the order parameter
                if(Array.isArray(viewConfig.order)) { // if the order element is a proper array
                    var missing = [];
                    var extra = [];
                    tempViewConfig.order.forEach(function (key) {
                        if(viewConfig.order.indexOf(key) === -1) {
                            missing.push(key);
                        }
                    });
                    viewConfig.order.forEach(function (key) {
                        if(availableBlocks.indexOf(key) === -1) {
                            extra.push(key);
                        }
                    });
                    if(extra.length !== 0) { // order has some unknown items, log them and remove from order.
                        log('Unknown order items [' + extra.toString() + '] will be removed');
                        viewConfig.order = viewConfig.order.filter(function(e) {
                            return extra.indexOf(e) < 0;
                        });
                    }
                    if(missing.length < 4) { //if order has atleast 3 required items, override default order
                        tempViewConfig.order = viewConfig.order;
                    } else log('Invalid order received, missing order items, ignoring it.', missing);
                } else log('Invalid order received, not an array ignoring it.', viewConfig.order);
            } else if (param === 'skin') { // prevent undefined slider skins to be used.
                if (!isSafesizeV2Skin(viewConfig[param]) && !isEsizeMeV2Skin(viewConfig[param])) {
                    if (self.sliderSkins[viewConfig[param].split('.')[0]] !== undefined) {
                        log('Slider skin ' + viewConfig[param].split('.')[0] + ' applied.');
                        tempViewConfig.sliderSkin = viewConfig[param].split('.')[0];
                    } else {
                        log('Slider skin ' + viewConfig[param].split('.')[0] + ' is not defined, reverting to default (safesize) skin.');
                    }
                }

            } else if (param === 'customColors') {
                var customColors = viewConfig[param];
                if(typeof customColors === 'object' && Object.keys(customColors).length > 0) {
                    Object.keys(customColors).forEach(function (key) {
                        var value = customColors[key].split(';')[0]; // splitting the string to prevent injection of styles
                        if (value !== '') {
                            tempViewConfig.customColors[key] = value;
                        }
                    });
                } else {
                    log('Invalid or empty customColors object passed, using safesize default.');
                }
            } else if(viewConfig[param] != null) {
                tempViewConfig[param] = viewConfig[param];
            }
        }
        if (tempViewConfig.sliderSkin === 'safesize' && tempViewConfig.customColors) {
            if (tempViewConfig.customColors.text1) self.sliderSkins.safesize.sliderInnerBarsColor = tempViewConfig.customColors.text1;
            if (tempViewConfig.customColors.text3) self.sliderSkins.safesize.footTextColor = self.sliderSkins.safesize.sliderTriangleColor = tempViewConfig.customColors.text3;
            if (tempViewConfig.customColors.text4) self.sliderSkins.safesize.sliderTextColor = self.sliderSkins.safesize.sliderOuterBarsColor = tempViewConfig.customColors.text4;
        }

        self.viewConfig = tempViewConfig;
        log('Applied config: ',  self.viewConfig);
    }

    // this.getSkinInfo = function (skin) {
    //     if(skinExists(skin)) {
    //         var sp = self.viewConfig.skin.split('.');
    //         return self.skins[sp[0]][sp[1]][sp[2]];
    //     }
    //     else return { errMsg: 'Skin \'' + skin + '\' not found'};
    // };

    this.init = function(parent, viewConfig, callback) { // initializer for datablocks
        // parent (string) if template needs to be loaded and added to DOM, otherwise it should be falsy,
        // viewConfig (object), all values from passed viewConfig will override the default ones in the component
        // callback (function), callback for sending events out of the component
        log('Initializing datablocks v' + version + ' received config: ',  viewConfig);
        updateViewConfig(viewConfig);
        self.callback = callback;
        if(parent) {
            getTemplate(function (response) {
                var parentEl = document.getElementsByClassName(parent);
                if(parentEl.length > 0) {
                    parentEl[0].insertAdjacentHTML('beforeend', response);
                    container = document.getElementsByClassName('datablocks_container')[0];
                    template = container.cloneNode(true);
                    initSubtask();
                } else {
                    self.callback('INIT_FAIL', {view: 'dataBlocks', message: 'Parent element not found, recheck the parent name.'});
                }
            });
        } else {
            container = document.getElementsByClassName('datablocks_container')[0];
            template = container.cloneNode(true);
            initSubtask();
        }
    };

    this.setLocalization = function (localization, locale) { // takes localization (json), locale (string) and applies translations to the blocks based on locale in viewConfig,
        // if locale is passed it overrides the viewConfig value -- for structure of the translate json check demo/foot.json
        if(localization != null) self.localization = localization;
        if(!locale) locale = self.viewConfig.locale;
        log('Setting localization:', localization, '\nSelected locale:', locale);
        var locales = { default: 'EN' };
        var keys = Object.keys(self.localization);
        if (keys.length && self.localization.hasOwnProperty(keys[0])) {
            for (var lang in self.localization[keys[0]]) {
                if (!locales.best) locales.best = lang; //first language from the translation JSON
                if (lang === locales.default) locales.best = lang; //override with default (EN) language if found
                if (lang === locale) { //override with input locale if found and exit search
                    locales.best = lang;
                    break;
                }
            }
        }
        self.viewConfig.locale = locales.best;
        var elements = document.querySelectorAll('[localize]');
        for(var idx = 0; idx < elements.length; idx++) {
            var element = elements[idx];
            var key = element.getAttribute('localize');
            var skinSplit = self.viewConfig.skin.split('.')[2].toUpperCase();
            if (self.localization[key + '_' + skinSplit]) key = key + '_' + skinSplit;
            if(!self.localization[key]) {
                alert('Missing localisation for key: ' + key);
            } else if (!self.localization[key][self.viewConfig.locale]) {
                alert('Missing locale ' + self.viewConfig.locale + ' for key: ' + key);
            } else if (!self.localization[key][self.viewConfig.locale].long){
                alert('Missing long localisation text for key ' + key + ' in locale: ' + self.viewConfig.locale);
            } else {
                element.innerHTML = self.localization[key][self.viewConfig.locale].long;
                continue;
            }
            element.innerHTML = key;
        }
    };

    this.setData = function (lastScan) { //takes lastScan json and applies it's data to the proper blocks.
        if (lastScan) { //if lastScan is passed, cache it
            self.lastScan = lastScan;
        } else {  // if lastScan is not passed, use the cached one.
            lastScan = self.lastScan;
        }
        log('Datablocks, data received: ', lastScan);
        if (lastScan.selectedSizingSystem) sizingSystem = lastScan.selectedSizingSystem;
        if (lastScan.selectedCustomerSystem) customerSystem = lastScan.selectedCustomerSystem;
        if (lastScan.person) gender = lastScan.person.isFemale ? 'F' : 'M';
        var locale = self.viewConfig.locale, localization = self.localization;
        measurment = lastScan.measurment;
        if(measurment.leftFoot && measurment.rightFoot) {
            if(measurment.leftFoot.footLength > measurment.rightFoot.footLength) {
                measurment.largerFoot = 'LEFT';
            } else if (measurment.leftFoot.footLength < measurment.rightFoot.footLength) {
                measurment.largerFoot = 'RIGHT';
            } else {
                measurment.largerFoot = (measurment.leftFoot.footWidth >= measurment.rightFoot.footWidth) ? 'LEFT' : 'RIGHT';
            }
        } else if(measurment.leftFoot) {
            measurment.largerFoot = 'LEFT';
        } else {
            measurment.largerFoot = 'RIGHT';
        }
        if (elements.block_size) {
            elements.block_size.querySelector('.size').innerHTML = lastScan.geometryInfo ? (Math.round(Math.max(lastScan.geometryInfo.footSizeLEFT, lastScan.geometryInfo.footSizeRIGHT) * 10) / 10).toString() : '-';
            elements.block_size.querySelector('.info').innerHTML = lastScan.person.isFemale ? localization.WOMEN[locale].long : localization.MEN[locale].long;
        }

        if (elements.block_video) {
            elements.block_video.querySelector('.video_box').play();
            elements.block_video.querySelector('.size').innerHTML = lastScan.geometryInfo ? (Math.round(Math.max(lastScan.geometryInfo.footSizeLEFT, lastScan.geometryInfo.footSizeRIGHT) * 10) / 10).toString() + ',' : '-';
        }

        if (elements.block_shoe_size_range && elements.block_shoe_size_range.querySelector('.size')) {
            elements.block_shoe_size_range.querySelector('.size').innerHTML = lastScan.geometryInfo ? (Math.round(Math.max(lastScan.geometryInfo.footSizeLEFT, lastScan.geometryInfo.footSizeRIGHT) * 10) / 10).toString() : '-';
        }
        if(elements.block_arch_type) {
            if (measurment.feetType != null) {
                elements.arch_icon.classList.remove('hollow', 'neutral', 'light_flat', 'flat');
                elements.arch_icon.classList.add(measurment.feetType.toLowerCase());
                elements.block_arch_type.querySelector('.arch_text').innerHTML = localization['ARCH_' + measurment.feetType.toUpperCase()][locale].long;
            } else {
                elements.arch_icon.classList.remove('hollow', 'neutral', 'light_flat', 'flat');
                elements.arch_icon.classList.add('neutral');
                elements.block_arch_type.querySelector('.arch_text').innerHTML = '-';
            }
        }
        var dimUnit = "mm";
        if(measurment.leftFoot != null) {
            dimUnit = measurment.leftFoot.dimUnit ? measurment.leftFoot.dimUnit : 'mm';
            if(elements.block_length) elements.block_length.querySelector('.leftfoot .number').innerHTML = (measurment.leftFoot.footLengthDim || Math.round(measurment.leftFoot.footLength)) + ' ' + dimUnit;  //perhaps consider inches and other units??
            if(elements.block_width) elements.block_width.querySelector('.leftfoot .number').innerHTML = (measurment.leftFoot.footWidthDim || Math.round(measurment.leftFoot.footWidth)) + ' ' + dimUnit;
            if(elements.block_height) elements.block_height.querySelector('.leftfoot .number').innerHTML = (measurment.leftFoot.footHeightDim || Math.round(measurment.leftFoot.footHeight || 0)) + ' ' + dimUnit;
            if(elements.block_girth) elements.block_girth.querySelector('.leftfoot .number').innerHTML = (measurment.leftFoot.footGirthDim || Math.round(measurment.leftFoot.footGirth)) + ' ' + dimUnit;
        }
        if(measurment.rightFoot != null) {
            dimUnit = measurment.rightFoot.dimUnit ? measurment.rightFoot.dimUnit : 'mm';
            if(elements.block_length) elements.block_length.querySelector('.rightfoot .number').innerHTML = (measurment.rightFoot.footLengthDim || Math.round(measurment.rightFoot.footLength)) + ' ' + dimUnit;
            if(elements.block_width) elements.block_width.querySelector('.rightfoot .number').innerHTML = (measurment.rightFoot.footWidthDim || Math.round(measurment.rightFoot.footWidth))  + ' ' + dimUnit;
            if(elements.block_height) elements.block_height.querySelector('.rightfoot .number').innerHTML = (measurment.rightFoot.footHeightDim || Math.round(measurment.rightFoot.footHeight) || 0)  + ' ' + dimUnit;
            if(elements.block_girth) elements.block_girth.querySelector('.rightfoot .number').innerHTML = (measurment.rightFoot.footGirthDim || Math.round(measurment.rightFoot.footGirth))  + ' ' + dimUnit;
        }
        if(lastScan.geometryInfo) {
            if (isSafesizeV2Skin()) {
                initHtmlSliders(lastScan.geometryInfo);
            } else if (!isEsizeMeV2Skin()) {
                initSliderCanvases(lastScan.geometryInfo);
            }
            if(elements.block_size) {
                initSizingSelectors(lastScan.geometryInfo, lastScan.brandFootSizes, elements.size_csystem, elements.size_ssystem, false);
            }
            if (elements.block_shoe_size_range) {
                initSizingSelectors(lastScan.geometryInfo, lastScan.brandFootSizes, elements.shoe_size_range_csystem, elements.shoe_size_range_ssystem, true);
            }
        } else {
            log('Missing geometry info, can\'t draw sliders or enable changing size systems');
        }
    };

    this.setSelectableDimensions = function (list) { //takes array of strings ['length','width',...] and applies styling to make the blocks selectable
        if (!self.viewConfig.selectable) return log('Can\'t set selectable dimensions because the viewConfig prohibits it!');
        if (!this.viewConfig.clickableArchType && list.indexOf('arch_type') > -1) list.splice(list.indexOf('arch_type'));
        for(var j in list) {
            if(list.hasOwnProperty(j)) {
                var el = elements['block_' + list[j].toLowerCase()];
                if (el) {
                    el.classList.add('selectable');
                    var checkbox = el.getElementsByClassName('checkbox-safesize')[0];
                    if (checkbox) {
                        checkbox.classList.remove('datablocks_removed');
                    }
                }
            }
        }
        var selectableBoxes = document.getElementsByClassName('box');
        for (var i = 0; i < selectableBoxes.length; i++) {
            if(selectableBoxes[i].classList.contains('selectable')) {
                selectableBoxes[i].addEventListener('click', selectDimension);
            }
        }
    };


    this.redraw = function () { // calls redraw on sliders
        drawSliders();
    };

    this.select = function (dimension, value, init) { // handles selecting of the block from code
        // dimension (string), describes which dimension it is
        // value (boolean) new selection value
        // init (boolean), just passed thru to event callback
        var el;
        switch (dimension.toUpperCase()) {
            case 'LENGTH':
                el = elements.block_length;
                break;
            case 'WIDTH':
                el = elements.block_width;
                break;
            case 'HEIGHT':
                el = elements.block_height;
                break;
            case 'GIRTH':
                el = elements.block_girth;
                break;
            case 'ARCH_TYPE':
                el = elements.block_arch_type;
                break;
            default:
                log('Invalid selection: ' + dimension.toUpperCase());
                break;
        }
        if(el) {
            if(el.classList.contains('selectable')) {
                el.classList.remove('selected');
                var checkbox = el.getElementsByClassName('checkbox-safesize')[0];
                if (checkbox) {
                    checkbox.checked = value;
                }
                if (value) el.classList.add('selected');
            } else {
                log('Invalid selection: ' + dimension + ' is not selectable');
                value = false;
            }
        } else value = false;
        self.callback(dimension.toUpperCase()+'_CB', {view: 'dataBlocks', value: value, init: init});
    };

    this.clear = function () { // clears the component data
        measurment = null;
        if(elements.block_size) {
            elements.block_size.querySelector('.size').innerHTML = '-';
            elements.block_size.querySelector('.info').innerHTML = '-';
            elements.size_csystem.parentNode.classList.add('datablocks_removed');
            elements.size_ssystem.parentNode.classList.add('datablocks_removed');
        }
        if (elements.block_shoe_size_range && elements.block_shoe_size_range.querySelector('.size')) {
            elements.block_shoe_size_range.querySelector('.size').innerHTML = '-';
            elements.shoe_size_range_csystem.parentNode.classList.add('datablocks_removed');
            elements.shoe_size_range_ssystem.parentNode.classList.add('datablocks_removed');
        }
        if(elements.block_width) {
            elements.block_width.querySelector('.rightfoot .number').innerHTML = '-';
            elements.block_width.querySelector('.leftfoot .number').innerHTML = '-';
        }
        if(elements.block_length) {
            elements.block_length.querySelector('.leftfoot .number').innerHTML = '-';
            elements.block_length.querySelector('.rightfoot .number').innerHTML = '-';
        }
        if(elements.block_arch_type) {
            elements.arch_icon.classList.remove('hollow', 'neutral', 'light_flat', 'flat');
            elements.block_arch_type.querySelector('.arch_text').innerHTML = '-';
        }
        if(elements.block_height) {
            elements.block_height.querySelector('.leftfoot .number').innerHTML = '-';
            elements.block_height.querySelector('.rightfoot .number').innerHTML = '-';
        }
        if(elements.block_girth) {
            elements.block_girth.querySelector('.leftfoot .number').innerHTML = '-';
            elements.block_girth.querySelector('.rightfoot .number').innerHTML = '-';
        }
        clearSelectableDimensions();
        clearSliderCanvases();
    };

    this.dispose = function () { // disposes the component and removes from dom
        self.lastScan = null;
        template = null;
        elements = null;
        document.getElementsByClassName('datablocks_container')[0].remove();
        sizingSystem = null;
        customerSystem = null;
        sliderWidth = null;
        sliderHeight = null;
        sliderGirth = null;
        measurment = null;
        self.viewConfig = null;
        self.callback = null;
    };

    function selectDimension(event) {
        var el = event.currentTarget || event.target;
        if (!el.classList.contains('selectable')) {
            while (!el.classList.contains('selectable')) { // traverse up on dom till the selectable block is found;
                el = el.parentElement;
            }
        }
        var checkbox = el.getElementsByClassName('checkbox-safesize')[0];
        var newSelVal;
        if (checkbox) {
            newSelVal = checkbox.checked = !checkbox.checked;
        } else {
            newSelVal = !el.classList.contains('selected');
        }
        el.classList.remove('selected');
        if (newSelVal)
            el.classList.add('selected');
        self.callback(el.id.split('_')[2].toUpperCase() + '_CB', {
            view: 'dataBlocks',
            value: newSelVal
        });
    }

    function onChange(event) {
        var el = event.currentTarget || event.target;
        if (el.id.indexOf('datablocks_block_') !== 0) {
            while (el.id.indexOf('datablocks_block_') !== 0) { // traverse up on dom till the selectable block is found;
                el = el.parentElement;
            }
        }
        var block_type = el.id.replace('datablocks_block_', '');
        self.callback(block_type.toUpperCase() + '_CHANGE', { view: "dataBlocks" });
    }

    function initSliderCanvases(geometryInfo) { // initializes canvas slider components with data from geometryInfo
        var localization = self.localization, locale = self.viewConfig.locale;
        if (elements.block_width) sliderWidth = new SliderView();
        if (elements.block_height) sliderHeight = new SliderView();
        if (elements.block_girth) sliderGirth = new SliderView();

        var boxes = document.querySelectorAll('.datablocks_container .box');
        for (var i = 0; i < boxes.length; i++) { //add class to move numbers upwards and make room for slider
            var box = boxes[i];
            if (['datablocks_block_size', 'datablocks_block_length', 'datablocks_block_arch_type'].indexOf(box.id.toString()) === -1) {
                box.classList.add('sliders_visible');
            }
        }

        var slidersConfig = self.sliderSkins[self.viewConfig.sliderSkin]; //IE compatibility fix

        slidersConfig.background = 'transparent';
        slidersConfig.leftIntervalLabel = localization.LEFT[locale].long;
        slidersConfig.rightIntervalLabel = localization.RIGHT[locale].long;

        if (sliderWidth) {
            slidersConfig.labels = [localization.NARROW[locale].long, localization.AVERAGE[locale].long, localization.WIDE[locale].long];
            slidersConfig.leftValue = (geometryInfo.footWidthLEFTDev + 3.0) / 6 * 100;
            slidersConfig.rightValue = (geometryInfo.footWidthRIGHTDev + 3.0) / 6 * 100;
            sliderWidth.init(elements.slider_width, elements.slider_width_wrapper, slidersConfig);
        }

        if(sliderHeight) {
            slidersConfig.labels = [localization.LOW[locale].long, localization.AVERAGE[locale].long, localization.HIGH[locale].long];
            slidersConfig.leftValue = (geometryInfo.instepHeightLEFTDev + 3.0) / 6 * 100;
            slidersConfig.rightValue = (geometryInfo.instepHeightRIGHTDev + 3.0) / 6 * 100;
            sliderHeight.init(elements.slider_height, elements.slider_height_wrapper, slidersConfig);
        }

        if(sliderGirth) {
            slidersConfig.labels = [localization.SMALL[locale].long, localization.AVERAGE[locale].long, localization.LARGE[locale].long];
            slidersConfig.leftValue = (geometryInfo.metatarsalGirthLEFTDev + 3.0) / 6 * 100;
            slidersConfig.rightValue = (geometryInfo.metatarsalGirthRIGHTDev + 3.0) / 6 * 100;
            sliderGirth.init(elements.slider_girth, elements.slider_girth_wrapper, slidersConfig);
        }

        if(document.fonts && document.fonts.load) {
            var tasks = 2;
            document.fonts.load(slidersConfig.textFont).then(function () { // force load the fonts if they haven't been loaded yet.
                if(--tasks === 0) {
                    self.fontLoaded = true;
                    drawSliders();
                }
            });
            document.fonts.load(slidersConfig.textFontLR).then(function () { // force load the fonts if they haven't been loaded yet.
                if(--tasks === 0) {
                    self.fontLoaded = true;
                    drawSliders();
                }
            });
        } else {
            drawSliders();
        }
    }

    function drawSliders() {
        if (isSafesizeV2Skin()) {
            return;
        }

        if (sliderWidth && self.viewConfig.order.indexOf('width') !== -1) sliderWidth.draw(true);
        if(self.viewConfig.modelVersion === '3D') {
            if (sliderHeight && self.viewConfig.order.indexOf('height') !== -1) sliderHeight.draw(true);
            if (sliderGirth && self.viewConfig.order.indexOf('girth') !== -1) sliderGirth.draw(true);
        }
    }

    function initHtmlSliders(geometryInfo) {
        var slidersConfig = {};
        if (elements.slider_width_wrapper) {
            slidersConfig.leftValue = (geometryInfo.footWidthLEFTDev + 3.0) / 6 * 100;
            slidersConfig.rightValue = (geometryInfo.footWidthRIGHTDev + 3.0) / 6 * 100;
            setStyleOnHtmlSliderElements(elements.slider_width_wrapper, slidersConfig);
        }

        if (elements.slider_height_wrapper) {
            slidersConfig.leftValue = (geometryInfo.instepHeightLEFTDev + 3.0) / 6 * 100;
            slidersConfig.rightValue = (geometryInfo.instepHeightRIGHTDev + 3.0) / 6 * 100;
            setStyleOnHtmlSliderElements(elements.slider_height_wrapper, slidersConfig);
        }

        if (elements.slider_girth_wrapper) {
            slidersConfig.leftValue = (geometryInfo.metatarsalGirthLEFTDev + 3.0) / 6 * 100;
            slidersConfig.rightValue = (geometryInfo.metatarsalGirthRIGHTDev + 3.0) / 6 * 100;
            setStyleOnHtmlSliderElements(elements.slider_girth_wrapper, slidersConfig);
        }
    }

    function setStyleOnHtmlSliderElements(wrapper, config) {
        var el = wrapper.getElementsByClassName('text_left');
        el[0].style.left = 'calc(' + config.leftValue + '% - 30px)';

        el = wrapper.getElementsByClassName('circle_left');
        el[0].style.left = 'calc(' + config.leftValue + '% - 8px)';

        el = wrapper.getElementsByClassName('text_right');
        el[0].style.left = 'calc(' + config.rightValue + '% - 30px)';

        el = wrapper.getElementsByClassName('circle_right');
        el[0].style.left = 'calc(' + config.rightValue + '% - 8px)';

        wrapper.classList.remove('hidden_visibility');
    }


    function prepareSizingobject (geometryInfo, brandFootSizes) { // creates a single mapping that is used for creating and managing size selectors
        //dev - start
        //brandFootSizes = null;
        //dev - end
        var sizing = { length: 0 }, ss, tmp;
        if(brandFootSizes) {
            log(brandFootSizes);
            for(var cs in brandFootSizes) {
                if(brandFootSizes.hasOwnProperty(cs) && brandFootSizes[cs].length > 0) {
                    sizing[cs] = { length: 0 };
                    for(ss in brandFootSizes[cs]) {
                        if (brandFootSizes[cs].hasOwnProperty(ss) && (!self.viewConfig.forcedSizingSystems || self.viewConfig.forcedSizingSystems.indexOf(ss) > -1)) {
                            tmp = brandFootSizes[cs][ss];
                            sizing[cs][tmp.sizeSystem] = {
                                sizeLEFT: tmp.sizeLEFT || 0,
                                sizeRIGHT: tmp.sizeRIGHT || 0,
                                widthMarkLEFT: tmp.widthMarkLEFT || '',
                                widthMarkRIGHT: tmp.widthMarkRIGHT || ''
                            };
                            sizing[cs].length++;
                        }
                    }
                    if (sizing[cs].length) {
                        sizing.length++;
                    } else {
                        delete sizing[cs];
                    }
                }
            }
        }
        //dev - start
        //geometryInfo.brannockFootSizes = null;
        //dev - end
        if(geometryInfo.brannockFootSizes && geometryInfo.brannockFootSizes.length > 0) {
            sizing.BRANNOCK = { length: 0 };
            //dev - start
            //geometryInfo.brannockFootSizes = [geometryInfo.brannockFootSizes[2]];
            //dev - end
            for(ss in geometryInfo.brannockFootSizes) {
                tmp = geometryInfo.brannockFootSizes[ss];
                if(geometryInfo.brannockFootSizes.hasOwnProperty(ss) && (!self.viewConfig.forcedSizingSystems || self.viewConfig.forcedSizingSystems.indexOf(tmp.footSizeSystem) > -1)) {
                    sizing.BRANNOCK[tmp.footSizeSystem] = {
                        sizeLEFT: tmp.footSizeLEFT || 0,
                        sizeRIGHT: tmp.footSizeRIGHT || 0,
                        widthMarkLEFT: tmp.widthMarkLEFT || '',
                        widthMarkRIGHT: tmp.widthMarkRIGHT || '',
                        sizeMod: tmp.footModSizeSystem.split(tmp.footSizeSystem)[1]
                    };
                    sizing.BRANNOCK.length++;
                }
            }
            if (sizing.BRANNOCK.length) {
                sizing.length++;
            } else {
                delete sizing.BRANNOCK;
            }
        } else if (geometryInfo.sizingFootSizes && geometryInfo.sizingFootSizes.length > 0) { //2018/6/12 only show safesize if brannock sizing is not present
            sizing.SAFESIZE = { length: 0 };
            for(ss in geometryInfo.sizingFootSizes) {
                tmp = geometryInfo.sizingFootSizes[ss];
                if(geometryInfo.sizingFootSizes.hasOwnProperty(ss) && (!self.viewConfig.forcedSizingSystems ||self.viewConfig.forcedSizingSystems.indexOf(tmp.footSizeSystem) > -1)) {
                    sizing.SAFESIZE[tmp.footSizeSystem] = {
                        sizeLEFT: tmp.footSizeLEFT ? tmp.footSizeLEFT.toFixed(1) : 0,
                        sizeRIGHT: tmp.footSizeRIGHT ? tmp.footSizeRIGHT.toFixed(1) : 0,
                        widthMarkLEFT: tmp.widthMarkLEFT ? tmp.widthMarkLEFT.toFixed(1) : '',
                        widthMarkRIGHT: tmp.widthMarkRIGHT ? tmp.widthMarkRIGHT.toFixed(1) : '',
                        sizeMod: tmp.footModSizeSystem ? tmp.footModSizeSystem.split(tmp.footSizeSystem)[1] : ''
                    };
                    sizing.SAFESIZE.length++;
                }
            }
            if (sizing.SAFESIZE.length) {
                sizing.length++;
            } else {
                delete sizing.SAFESIZE;
            }
        }
        return sizing;
    }

    function initSizingSelectors(geometryInfo, brandFootSizes, csystem, ssystem, isRange) { // initializes sizing selectors
        var _sizingObj = prepareSizingobject(geometryInfo, brandFootSizes);
        while (csystem.firstChild) {
            csystem.removeChild(csystem.firstChild);
        }

        if(_sizingObj.length > 1)
            csystem.parentNode.classList.remove('datablocks_removed');
        else
            csystem.parentNode.classList.add('datablocks_removed');

        if (customerSystem && _sizingObj[customerSystem]) {
            log('Customer system from lastScan applied.');
        } else if (self.viewConfig.customerSystem && _sizingObj[self.viewConfig.customerSystem]) {
            customerSystem = self.viewConfig.customerSystem;
            log('Customer system from viewConfig applied.');
        } else {
            for( var cs in _sizingObj) {
                if(_sizingObj[cs] instanceof Object) {
                    log('First available customer system applied as a fallback.', [customerSystem, self.viewConfig.customerSystem, cs]);
                    customerSystem = cs;
                    break;
                }
            }
        }

        sizingObj = {};
        Object.keys(_sizingObj).sort().forEach(function (key) {
            sizingObj[key] = _sizingObj[key];
        });

        for (var idx in sizingObj) {
            if (sizingObj[idx] && sizingObj[idx] instanceof Object) {
                var option = document.createElement('option');
                option.value = idx;
                option.innerHTML = idx;
                csystem.appendChild(option);
            }
        }

        csystem.value = customerSystem;

        if(sizingObj.length > 0) {
            updateUnitSelector(ssystem, isRange);
        }

        csystem.addEventListener('change', function () {
            customerSystem = this.value;
            updateUnitSelector(ssystem, isRange);
        });
    }

    function updateUnitSelector(ssystem, isRange) { // clears and fills unit selector with the sizing systems from selected consumerSystem
        while (ssystem.firstChild) {
            ssystem.removeChild(ssystem.firstChild);
        }

        for (var idx in sizingObj[customerSystem]) {
            if (sizingObj[customerSystem].hasOwnProperty(idx) && sizingObj[customerSystem][idx] && sizingObj[customerSystem][idx] instanceof Object) {
                var option = document.createElement('option');
                option.value = idx;
                option.innerHTML = idx;
                ssystem.appendChild(option);
            }
        }

        var shoesize = ssystem.parentNode.parentNode.querySelector('span.shoe_size.size_system');
        if (ssystem.childNodes.length > 1) {
            ssystem.parentNode.classList.remove('datablocks_removed');
            shoesize.textContent = '';
        } else {

            if (ssystem.childNodes.length === 1 && shoesize) {
                shoesize.textContent = ssystem.value;
            } else if (shoesize) {
                shoesize.textContent = '';
            }
            ssystem.parentNode.classList.add('datablocks_removed');
        }

        if(sizingSystem && sizingObj[customerSystem][sizingSystem]) { // try using last sizingSystem, if fails try default, otherwise use first available
            log('Sizing system from lastScan applied.');
            ssystem.value = sizingSystem;
        } else if(self.viewConfig.sizingSystem && sizingObj[customerSystem][self.viewConfig.sizingSystem]) {
            log('Sizing system from viewConfig applied.');
            sizingSystem = self.viewConfig.sizingSystem;
            ssystem.value = sizingSystem;
        } else {
            log('First available sizing system applied as a fallback.', [sizingSystem, self.viewConfig.sizingSystem, ssystem.value]);
            sizingSystem = ssystem.value;
        }
        if (elements.block_shoe_size_range && elements.block_shoe_size_range.querySelector('.range_wrapper')) {
            updateRanges();
        } else {
            updateSize(isRange);
        }

        ssystem.addEventListener('change', function () {
            sizingSystem = this.value;
            if (elements.block_shoe_size_range && elements.block_shoe_size_range.querySelector('.range_wrapper')) {
                updateRanges();
            } else {
                updateSize(isRange);
            }
        });
    }

    function getRoundedSize(size, system) {
        if (system === 'EU') {
            return Math.round(size);
        }
        var _fullSize = Math.floor(size);
        var _decimal = size - _fullSize;
        if (_decimal === 0 || _decimal === 0.5) {
            return size;
        }
        if (_decimal >= 0.75) {
            return _fullSize + 1;
        }
        if (_decimal >= 0.25) {
            return _fullSize + 0.5;
        }
        return _fullSize;
    }

    function updateSize(isRange) { //updates the size display (number + child/width) and toggles class for smaller font
        var size = sizingObj[customerSystem][sizingSystem]['size'+measurment.largerFoot];
        if (isRange) {
            size = createSizeRange(size, sizingSystem);
        } else if (self.viewConfig.round_size === 1) {
            log('Rounding size:', size, sizingSystem);
            size = getRoundedSize(size, sizingSystem);
        }
        var extra = ' ';
        if (sizingObj[customerSystem][sizingSystem].sizeMod) {
            extra += sizingObj[customerSystem][sizingSystem].sizeMod;
        } else {
            extra += sizingObj[customerSystem][sizingSystem]['widthMark'+measurment.largerFoot];
        }

        if(elements.block_size) {
            elements.block_size.querySelector('.size').innerHTML = size + extra;
            if (extra.length > 1)
                elements.block_size.querySelector('.size').classList.add('mod');
            else
                elements.block_size.querySelector('.size').classList.remove('mod');
        }

        if (elements.block_shoe_size_range && elements.block_shoe_size_range.querySelector('.size')) {
            elements.block_shoe_size_range.querySelector('.size').innerHTML = size + extra;
            if (extra.length > 1)
                elements.block_shoe_size_range.querySelector('.size').classList.add('mod');
            else
                elements.block_shoe_size_range.querySelector('.size').classList.remove('mod');
        }
    }

    function updateRanges() {
        var coif = sizingSystem === 'MP' ? 10 : 1;
        var floatSize = (sizingObj[customerSystem][sizingSystem]['size'+measurment.largerFoot] / coif % 1).toFixed(1);

        var leftTxt;
        var middleTxt;
        var rightTxt;

        var percentages;

        if (sizingSystem === 'EU') {
            percentages = euSystemPercentage[floatSize.toString()];
            var euSize;
            if (floatSize <= 0.4) {
                euSize = Math.floor(sizingObj[customerSystem][sizingSystem]['size'+measurment.largerFoot]);
            } else {
                euSize = Math.ceil(sizingObj[customerSystem][sizingSystem]['size'+measurment.largerFoot]);
            }
            leftTxt = ((euSize - 1) * coif);
            middleTxt = (euSize * coif);
            rightTxt = ((euSize + 1) * coif);

        } else {
            percentages = ukUsSystemPercentage[floatSize.toString()];
            var ukUsSize;
            if (floatSize <= 0.2) {
                ukUsSize = Math.floor(sizingObj[customerSystem][sizingSystem]['size'+measurment.largerFoot] / coif);
            } else if (floatSize >= 0.3 && floatSize <= 0.7){
                ukUsSize = Math.floor(sizingObj[customerSystem][sizingSystem]['size'+measurment.largerFoot] / coif) + 0.5;
            } else {
                ukUsSize = Math.floor(sizingObj[customerSystem][sizingSystem]['size'+measurment.largerFoot] / coif) + 1;
            }

            if (sizingSystem === 'UK' || sizingSystem === 'US') {
                if (ukUsSize === 0) {
                    leftTxt = 13 - 0.5 + 'C';
                    middleTxt = '13C';
                    rightTxt = ukUsSize + 0.5;
                } else if (ukUsSize >= 13.5 && sizingObj[customerSystem][sizingSystem].sizeMod) {
                    leftTxt = (ukUsSize -  0.5) + sizingObj[customerSystem][sizingSystem].sizeMod;
                    middleTxt = ukUsSize - 13;
                    rightTxt = ukUsSize - 13 + 0.5;
                } else if (sizingObj[customerSystem][sizingSystem].sizeMod) {
                    leftTxt = ((ukUsSize - 0.5) * coif) + sizingObj[customerSystem][sizingSystem].sizeMod;
                    middleTxt = ((ukUsSize) * coif) + sizingObj[customerSystem][sizingSystem].sizeMod;
                    rightTxt = ((ukUsSize + 0.5) * coif) + sizingObj[customerSystem][sizingSystem].sizeMod;
                } else {
                    leftTxt = (ukUsSize - 0.5) * coif;
                    middleTxt = (ukUsSize) * coif;
                    rightTxt = (ukUsSize + 0.5) * coif;
                }
            } else {
                leftTxt = (ukUsSize - 0.5) * coif;
                middleTxt = (ukUsSize) * coif;
                rightTxt = (ukUsSize + 0.5) * coif;
            }

        }

        if (isPercentageSkin()) {
            elements.block_shoe_size_range.querySelector('.left-front').style.background = leftTxt > middleTxt ? "#026eb6" : "#4FABE0";
            elements.block_shoe_size_range.querySelector('.middle-front').style.background = leftTxt < middleTxt ? "#026eb6" : "#4FABE0";

            elements.block_shoe_size_range.querySelector('.range_percentage_left').style.color = leftTxt > middleTxt ? "#026eb6" : "#4FABE0";
            elements.block_shoe_size_range.querySelector('.range_percentage_middle').style.color = leftTxt < middleTxt ? "#026eb6" : "#4FABE0";
        }

        elements.block_shoe_size_range.querySelector('.left-txt').innerHTML = leftTxt;
        elements.block_shoe_size_range.querySelector('.middle-txt').innerHTML = middleTxt;
        elements.block_shoe_size_range.querySelector('.right-txt').innerHTML = rightTxt;

        elements.block_shoe_size_range.querySelector('.left-front').style.height = percentages[0] + '%';
        elements.block_shoe_size_range.querySelector('.middle-front').style.height = percentages[1] + '%';
        elements.block_shoe_size_range.querySelector('.right-front').style.height = percentages[2] + '%';

        elements.block_shoe_size_range.querySelector('.range_percentage_left').innerHTML = percentages[0] + '%';
        elements.block_shoe_size_range.querySelector('.range_percentage_middle').innerHTML = percentages[1] + '%';
        elements.block_shoe_size_range.querySelector('.range_percentage_right').innerHTML = percentages[2] + '%';

        elements.block_shoe_size_range.querySelector('.range_description').innerHTML = self.localization.SHOE_SIZE_RANGE_ADVICE[self.viewConfig.locale].long.replace('{{percent}}', percentages[1] + '%').replace('{{size}}', middleTxt);
    }

    function createSizeRange(size, sizingSystem) {
        if (["EU", "UK", "US", "JP", "MP"].indexOf(sizingSystem) === -1) {
            return size;
        }

        try {
            var min = Math.floor(size);
            var max = Math.ceil(size);
            var minRange = min;
            var maxRange = max;
            var diff = 0.2;

            if (isNaN(min) || isNaN(max)) {
                return size;
            }

            var closerToMin = function(diff){
                return (size - min).toFixed(1) <= diff;
            };
            var closerToMax = function(diff){
                return (max - size).toFixed(1) <= diff;
            };
            //checks which value is closer and corrects it up/down by diff
            var calculateMinMaxRange = function(diff){
                //if diff === 1, minRange and maxRange stay the same
                if(diff===1){
                    //if 7.0, max is set to 8
                    if(min == max) maxRange += diff;
                } else {
                    //if 7.0, max is set to 7.5, min is 7 by default
                    if(min == max) return maxRange += diff;
                    //if 7.5 min is set to 7.5, max is 8 by default
                    if((size-min)===diff) return minRange+= diff;
                    if (closerToMax(diff)) minRange+=diff;
                    if (closerToMin(diff)) maxRange-=diff;
                }
            };
            var isHotter = isHotterSkin(self.viewConfig.skin);
            var isBrannock = customerSystem === 'BRANNOCK';
            if(isHotter && isBrannock){ //TBD: use hotter size table for range
                diff = 1;
                if(sizingSystem === 'EU'){
                    if(gender === 'M'){
                        //top of range is 41, if below diff===2
                        if(size<41){
                            if(minRange>=39) maxRange='41';
                            else maxRange+=2;
                            return minRange+'-'+maxRange;
                        }
                        if (41<=size && size<43) diff=0.5;
                    } else {
                        if(size<39) diff=0.5;
                        if(41<=size && size<42) diff=0.5;
                    }
                } else if (sizingSystem === 'US'){
                    if(gender === 'M'){
                        if(8<=size && size<11) diff=0.5;
                    } else {
                        if(size<10) diff=0.5;
                    }
                } else if (sizingSystem==='UK'){
                    if(gender === 'M'){
                        if(7<=size && size<10) diff=0.5;
                    } else {
                        if(size<8) diff=0.5;
                    }
                }
                calculateMinMaxRange(diff);
                return minRange + '-' + maxRange;
            } else {
                if (sizingSystem === 'EU') {
                    if (closerToMax(diff)) max++;
                    if (closerToMin(diff)) min--;
                }
                else {
                    var step = 0.5;
                    if (sizingSystem === 'MP') {
                        diff = 2.0;
                        step = 5.0;
                    }

                    if (closerToMin(diff)) {
                        min -= step;
                        max -= step;
                        if (min === max) {
                            max++;
                        }
                    }

                    if (closerToMax(diff)) {
                        min += step;
                        max += step;
                    }

                }
                return min + '-' + max;
            }
        }
        catch(ex) {
            log('Error while creating shoe size ranges, returning the original size. Exception: ' + ex);
            return size;
        }
    }

    function clearSliderCanvases() { //clears slider canvases
        if(sliderWidth) sliderWidth.clear();
        if(sliderHeight) sliderHeight.clear();
        if(sliderGirth) sliderGirth.clear();
    }

    function clearSelectableDimensions () { //clears styling that makes the blocks selectable
        var boxes = document.getElementsByClassName('box'); //changed to only box because i was getting only 2 boxes cleared instead of all 4
        for (var i = 0; i < boxes.length; i++) {
            var box = boxes[i];
            box.removeEventListener('click', selectDimension);
            if(box.classList.contains('selectable')) {
                box.classList.remove('selectable', 'selected');
                var checkbox = box.getElementsByClassName('checkbox-safesize')[0];
                if (checkbox) {
                    checkbox.checked = false;
                    checkbox.classList.add('datablocks_removed');
                }
            }
        }
    }

    this.version = function () { // returns version number
        return version;
    };

    function applyThemeColoring() { //applies style to the DOM to overwrite color theme
        var customColors = self.viewConfig.customColors;
        var style_id = 'custom_style';
        var appendToHead;
        if (customColors) {
            var styleElement = document.getElementById(style_id);

            if (!styleElement) {
                appendToHead = true;
                styleElement = document.createElement('style');
            }

            styleElement.id = style_id;
            styleElement.innerHTML = '.datablocks_container .box {\n' +
                '  background-color: ' + customColors.box1 + ';\n' +
                '  color: ' + customColors.text1 + ';\n' +
                '}\n' +

                '.datablocks_container .box p.info {\n' +
                '  color: ' + customColors.text2 + ';\n' +
                '}\n' +

                '.datablocks_container .box.selectable:hover {\n' +
                '  border-color: ' + customColors.box3 + ';\n' +
                '  background-color: ' + customColors.box2 + ';\n' +
                '  box-shadow: inset 0 0 5px 3px ' + customColors.box3 + ';\n' +
                '}\n' +

                'body.touch .datablocks_container .box.selectable:hover {\n' +
                '  border-color: transparent;\n' +
                '  background-color: ' + customColors.box2 + ';\n' +
                '  box-shadow: none;\n' +
                '}\n' +

                '.datablocks_container .box.selected {\n' +
                '  border-color: ' + customColors.box5 + ';\n' +
                '  background-color: ' + customColors.box4 + ';\n' +
                '  box-shadow: inset 3px 3px 10px 3px ' + customColors.box6 + ';\n' +
                '}\n' +

                '.datablocks_container .select {\n' +
                '  background-color: ' + customColors.sbox1 + ';\n' +
                '}\n' +

                '.datablocks_container select {\n' +
                '  color: ' + customColors.text3 + ';\n' +
                '}\n' +

                '.datablocks_container .select::after {\n' +
                '  color: ' + customColors.text3 + ';\n' +
                '}\n' +

                '.datablocks_container select option {\n' +
                '  background-color: ' + customColors.sbox1 + ';\n' +
                '}\n' +

                '.datablocks_container .box.selected:hover {\n' +
                '  border-color: ' + customColors.box5 + ';\n' +
                '  box-shadow: inset 3px 3px 10px 3px ' + customColors.box6 + ';\n' +
                '}\n' +

                'body.touch .datablocks_container .box.selected:hover {\n' +
                '  background-color: ' + customColors.box4 + ';\n' +
                '  border-color: ' + customColors.box5 + ';\n' +
                '  box-shadow: inset 3px 3px 10px 3px ' + customColors.box6 + ';\n' +
                '}\n' +

                '.datablocks_container .checkbox-safesize+label {\n' +
                '  border: 1px solid' + customColors.cbox2 + ';\n' +
                '}\n' +

                '.datablocks_container .checkbox-safesize:hover+label {\n' +
                '  border-color: ' + customColors.cbox1 + ';\n' +
                '}\n' +

                '.datablocks_container .checkbox-safesize:checked+label {\n' +
                '  border-color: ' + customColors.cbox1 + ';\n' +
                '}\n' +

                '.datablocks_container .checkbox-safesize+label img {\n' +
                '  filter: ' + customColors.cboxf + '\n' +
                '}\n';

            if(appendToHead) {
                document.head.appendChild(styleElement);
            }
            if (elements.arch_icon) {
                elements.arch_icon.classList.remove('white');
                elements.arch_icon.classList.remove('black');
                elements.arch_icon.classList.remove('gray');
                elements.arch_icon.classList.add(self.viewConfig.customColors.feet);
            }
        }
    }

    function isEsizeMeV2Skin(skin) {
        if (!skin) {
            skin = self.viewConfig.skin;
        }
        return skin.indexOf('esizemev2.') === 0;
    }

    function isSafesizeV2Skin(skin) {
        if (!skin) {
            skin = self.viewConfig.skin;
        }
        return skin.indexOf('safesizev2.') === 0;
    }

    function isLsRangeSkin(skin) {
        if (!skin) {
            skin = self.viewConfig.skin;
        }
        return skin.indexOf('.ls_range');
    }

    function isPercentageSkin(skin) {
        if (!skin) {
            skin = self.viewConfig.skin;
        }
        return skin.indexOf('_perc') > -1 || skin.indexOf('percentage') > -1;
    }

    function isHotterSkin(skin) {
        if (!skin) {
            skin = self.viewConfig.skin;
        }
        var split = skin.split('.');
        return split.indexOf('safesizev2') === 0 && split.indexOf('hotter') === 2;
    }
}

//UMD
if (typeof define === 'function' && define.amd) {
    //AMD module
    define('datablock', function(){ return DataBlocks; });
} else if (typeof module === 'object' && module.exports) {
    //CommonJS module
    module.exports = function(){ return DataBlocks; };
}
//# sourceMappingURL=dataBlocks.js.map
